module.exports = "/src/views/player/hudevo/ipad/assets/images/camera.png";